import { collection, doc, addDoc, query, orderBy, onSnapshot, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../config/firebase"; // Adjust path if needed (e.g. '../firebase.js')

class FirebaseChatService {
  // 1. LISTEN TO ALL CHATS (List View)
  // Queries the "chats" collection, ordered by activity
  subscribeToAllChats(callback) {
    const q = query(collection(db, "chats"), orderBy("lastMessageAt", "desc"));

    return onSnapshot(q, (snapshot) => {
      const chats = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      callback(chats);
    });
  }

  // 2. LISTEN TO MESSAGES (Detail View)
  // Queries the "messages" subcollection of a specific chat
  subscribeToChatMessages(chatId, callback) {
    const q = query(collection(db, "chats", chatId, "messages"), orderBy("createdAt", "asc"));

    return onSnapshot(q, (snapshot) => {
      const messages = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      callback(messages);
    });
  }

  // 3. SEND MESSAGE
  async sendMessage(chatId, text, senderEmail, senderRole = "admin") {
    if (!text.trim()) return;

    const chatRef = doc(db, "chats", chatId);
    const messagesRef = collection(db, "chats", chatId, "messages");

    // A. Add to subcollection
    await addDoc(messagesRef, {
      text: text,
      sender: senderRole,
      email: senderEmail,
      createdAt: serverTimestamp(),
    });

    // B. Update list view metadata
    await setDoc(
      chatRef,
      {
        lastMessage: text,
        lastMessageAt: serverTimestamp(),
        lastMessageSender: senderRole,
        email: chatId,
      },
      { merge: true },
    );
  }
}

export default new FirebaseChatService();
